import { get, post, Response } from '@/api'
import { Password } from '@/modules/user/types'
import {
  AuthTokens,
  ChangePasswordDto,
  CustomTerms,
  EmailStatus,
  InvitationRegistration,
  PasswordResetDto,
  SelfInvite,
  SelfRegistration,
  Token,
  ValidTokenDto
} from '@/types/index'

export default {
  getAccessToken: (refreshToken: string): Promise<Response<AuthTokens>> => {
    return get<AuthTokens>('/user/actions/access-token', {
      headers: {
        Authorization: `Bearer ${refreshToken}`
      }
    })
  },
  getLoginRefreshToken: (basicAuthString: string): Promise<Response<string>> => {
    return get<string>('/user/actions/login', {
      headers: {
        Authorization: basicAuthString
      }
    })
  },
  resetPassword: (data: PasswordResetDto): Promise<Response<string>> => {
    return post<string, PasswordResetDto>('/user/actions/reset-password', data)
  },
  checkPasswordToken: (data: Token): Promise<Response<Token>> => {
    return post<Token, Token>('/user/actions/validate-password-token', data)
  },
  checkRegisterToken: (data: Token): Promise<Response<ValidTokenDto>> => {
    return post<ValidTokenDto, Token>('/registration/invitation/validate-token', data)
  },
  changePassword: (data: ChangePasswordDto): Promise<Response<Token>> => {
    return post<Token, ChangePasswordDto>('/user/actions/change-password', data)
  },
  validateRegistrationEmail: (email: string): Promise<Response<EmailStatus>> => {
    return post<EmailStatus, { email: string }>('/registration/validate-mail', {
      email
    })
  },
  getCustomTerms: (lang: string): Promise<Response<CustomTerms>> => {
    return get<CustomTerms>('/registration/customterms', {
      params: { lang }
    })
  },
  finishRegistration: (data: InvitationRegistration): Promise<Response<string>> => {
    return post<string, InvitationRegistration>('/registration/invitation', data)
  },
  guestRegistration: (data: Password): Promise<Response<string>> => {
    return post<string, Password>('/guest/registration', data)
  },
  executeSelfRegistration: (data: SelfRegistration): Promise<Response<string>> => {
    return post<string, SelfRegistration>('/registration', data)
  },
  selfInvite: (data: SelfInvite): Promise<Response<string>> => {
    return post<string, SelfInvite>('/registration/self-invite', data)
  }
}
